<script setup>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import {router, Link} from "@inertiajs/vue3";
import DashboardSvg from "@svg/new-dashboard.svg";
import ProfileSvg from '@svg/new-profile.svg'
import ChevronSvg from "@svg/new-chevron.svg";
import SignOutSvg from "@svg/new-signout.svg";
import MembershipSvg from "@svg/new-membership.svg";
import useCloudflareImage from '../../../Composables/useCloudflareImage.js'

const { cloudflareImage } = useCloudflareImage()
</script>

<template>
    <Menu v-if="$page.props.auth.user" class="ml-5 relative -mr-5 z-50" as="div" v-slot="{ open }">
        <transition
            enter-active-class="transition ease-out"
            enter-from-class="transform scale-95 opacity-0 -translate-y-2"
            leave-active-class="transition ease-out"
            leave-to-class="transform scale-95 opacity-0 -translate-y-2"
        >
            <MenuItems class="w-full bg-[rgba(14,20,53,1)] absolute top-0 left-0 rounded-xl pt-24 p-5 space-y-2.5 ui-focus-visible:ring-2 ui-focus-visible:ring-offset-2 focus:outline-none" as="ul">
                <MenuItem as="div" v-slot="{ close }" v-if="!$page.props.auth.user.subscription.active">
                    <Link :href="`/user/membership`" v-on:click="close" class="bg-[rgba(25,27,67,1)] text-[rgba(132,156,241,1)] text-sm px-3.5 py-2 rounded-lg flex items-center space-x-2.5">
                        <MembershipSvg class="size-5" />
                        <span>Membership</span>
                    </Link>
                </MenuItem>
                <MenuItem as="div" v-slot="{ close }">
                    <Link :href="`/user/activity`" v-on:click="close" class="bg-[rgba(25,27,67,1)] text-[rgba(132,156,241,1)] text-sm px-3.5 py-2 rounded-lg flex items-center space-x-2.5">
                        <DashboardSvg class="size-5" />
                        <span>Dashboard</span>
                    </Link>
                </MenuItem>
                <MenuItem as="div" v-slot="{ close }">
                    <Link :href="`/user/profile`" v-on:click="close" class="bg-[rgba(25,27,67,1)] text-[rgba(132,156,241,1)] text-sm px-3.5 py-2 rounded-lg flex items-center space-x-2.5">
                        <ProfileSvg class="size-5" />
                        <span>Profile</span>
                    </Link>
                </MenuItem>
                <MenuItem as="div">
                    <button v-on:click="router.post('/logout')" class="w-full">
                        <div class="bg-[rgba(25,27,67,1)] text-[rgba(132,156,241,1)] text-sm px-3.5 py-2 rounded-lg flex items-center space-x-2.5">
                            <SignOutSvg class="size-5" />
                            <span>Sign out</span>
                        </div>
                    </button>
                </MenuItem>
            </MenuItems>
        </transition>

        <!-- drop-shadow-none is a hack to get negative z-index to be overlayed and clickable. do not remove it -->
        <MenuButton as="div" class="flex items-center pl-6 lg:pl-5 py-5 lg:py-2 drop-shadow-none cursor-pointer" aria-label="User menu">
            <img :src="cloudflareImage($page.props.auth.user.avatar)" class="lg:opacity-100 transition-opacity rounded-full h-10 w-10 ring-offset-2 ring-2 ring-offset-[rgba(8,13,39,1)] mr-5" :class="{ 'ring-[rgba(65,251,220,1)]': $page.props.auth.user.subscription.active, 'ring-[rgba(255,207,83,1)]': !$page.props.auth.user.subscription.active, 'opacity-0': !open }" alt="Profile photo">
            <div class="space-y-1.5 lg:opacity-100 transition-opacity" :class="{ 'opacity-0': !open }">
                <div class="text-base text-[rgba(235,248,255,1)] leading-none font-medium lg:max-w-[120px] truncate">
                    {{ $page.props.auth.user.first_name }}
                </div>
                <div class="inline-block rounded-full border-[1.5px] text-xs leading-none px-2.5 py-1" :class="{ 'border-[rgba(65,251,220,1)] text-[rgba(65,251,220,1)] shadow-[2px_2px_8px_rgba(26,188,151,0.3)]': $page.props.auth.user.subscription.active, 'border-[rgba(255,207,83,1)] text-[rgba(255,207,83,1)] shadow-[2px_2px_8px_rgba(255,207,83,0.3)]': !$page.props.auth.user.subscription.active }">
                    {{ $page.props.auth.user.subscription.active ? ($page.props.auth.user.subscription.lifetime ? 'Lifetime' : 'Pro') : `Free` }}
                </div>
            </div>
            <div class="p-5 ui-focus-visible:ring-2 ui-focus-visible:ring-offset-2 focus:outline-none">
                <div class="bg-[rgba(25,27,67,1)] h-6 w-6 rounded-full items-center justify-center flex">
                    <ChevronSvg class="size-6 transition-transform" :class="{ 'rotate-180': open, 'text-[rgba(65,251,220,1)]': $page.props.auth.user.subscription.active, 'text-[rgba(255,207,83,1)]': !$page.props.auth.user.subscription.active }" />
                </div>
            </div>
        </MenuButton>
    </Menu>
</template>
